module.exports = __webpack_public_path__ + "static/media/homepage_2.64234282.jpg";